"use client";

import React from "react";
import { Shield, Mail, Send, Loader, Info } from "lucide-react";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { FormProvider, useWvcForm } from "@/integrations/forms/FormProvider";
import { Form, FormField, FormItem, FormLabel, FormControl, FormMessage } from "@/components/ui/form";
import { Input } from "@/components/ui/input";
import { Textarea } from "@/components/ui/textarea";
import { Button } from "@/components/ui/button";
import { Card, CardContent } from "@/components/ui/card";
const contactInfo = [{
  icon: Shield,
  title: "Datenschutzbeauftragter",
  description: "Unser Datenschutzbeauftragter überwacht die Einhaltung aller relevanten Datenschutzvorschriften und steht Ihnen bei Fragen zur Verfügung."
}, {
  icon: Info,
  title: "Ihre Rechte",
  description: "Sie haben das Recht auf Auskunft, Berichtigung, Löschung und Einschränkung der Verarbeitung Ihrer personenbezogenen Daten."
}];
function PrivacyContactForm() {
  const {
    isSubmitting,
    isSubmitted,
    submitError,
    successMessage,
    handleSubmit,
    resetForm,
    control
  } = useWvcForm();
  if (isSubmitted && !submitError) {
    return <Card className="bg-primary-foreground/5 border-primary-foreground/10">
        <CardContent className="pt-6 flex flex-col items-center text-center space-y-4">
          <div className="size-12 rounded-lg bg-ring/20 flex items-center justify-center text-ring">
            <Shield className="size-6" />
          </div>
          <h3 className="text-xl font-default font-semibold text-primary-foreground">Anfrage übermittelt</h3>
          <p className="text-primary-foreground/70 font-default">{successMessage}</p>
          <Button onClick={resetForm} variant="outline" className="mt-4 border-primary-foreground/20 text-primary-foreground hover:bg-primary-foreground/10">
            Weitere Anfrage senden
          </Button>
        </CardContent>
      </Card>;
  }
  return <Form onSubmit={handleSubmit} className="space-y-6">
      <div className="space-y-4">
        <FormField control={control} name="name" rules={{
        required: "Bitte geben Sie Ihren Namen an",
        minLength: {
          value: 2,
          message: "Der Name muss mindestens 2 Zeichen lang sein"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground">Vollständiger Name</FormLabel>
              <FormControl>
                <Input placeholder="Max Mustermann" className="bg-primary-foreground/5 border-primary-foreground/20 text-primary-foreground placeholder:text-primary-foreground/40 focus-visible:ring-ring" {...field} />
              </FormControl>
              <FormMessage className="text-destructive-foreground bg-destructive/20 px-2 py-1 rounded-md inline-block mt-1" />
            </FormItem>} />

        <FormField control={control} name="email" rules={{
        required: "Bitte geben Sie Ihre E-Mail-Adresse an",
        pattern: {
          value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
          message: "Bitte geben Sie eine gültige E-Mail-Adresse ein"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground">E-Mail-Adresse</FormLabel>
              <FormControl>
                <Input type="email" placeholder="max@beispiel.de" className="bg-primary-foreground/5 border-primary-foreground/20 text-primary-foreground placeholder:text-primary-foreground/40 focus-visible:ring-ring" {...field} />
              </FormControl>
              <FormMessage className="text-destructive-foreground bg-destructive/20 px-2 py-1 rounded-md inline-block mt-1" />
            </FormItem>} />

        <FormField control={control} name="message" rules={{
        required: "Bitte beschreiben Sie Ihr Anliegen",
        minLength: {
          value: 10,
          message: "Die Nachricht muss mindestens 10 Zeichen lang sein"
        }
      }} render={({
        field
      }) => <FormItem>
              <FormLabel className="text-primary-foreground">Ihr Anliegen</FormLabel>
              <FormControl>
                <Textarea placeholder="Wie können wir Ihnen bezüglich Ihrer Daten helfen?" className="bg-primary-foreground/5 border-primary-foreground/20 text-primary-foreground placeholder:text-primary-foreground/40 focus-visible:ring-ring min-h-[120px]" {...field} />
              </FormControl>
              <FormMessage className="text-destructive-foreground bg-destructive/20 px-2 py-1 rounded-md inline-block mt-1" />
            </FormItem>} />
      </div>

      {submitError && <div className="p-4 bg-destructive/20 border border-destructive/50 rounded-lg">
          <p className="text-destructive-foreground text-sm font-default">{submitError}</p>
        </div>}

      <Button type="submit" disabled={isSubmitting} className="w-full bg-ring text-primary-foreground hover:bg-ring/90 shadow-lg shadow-ring/20" size="lg">
        {isSubmitting ? <>
            <Loader className="animate-spin mr-2 size-5" />
            Wird gesendet...
          </> : <>
            <Send className="mr-2 size-5" />
            Anfrage sicher übermitteln
          </>}
      </Button>
      
      <p className="text-xs text-primary-foreground/50 text-center font-default mt-4">
        Ihre Daten werden verschlüsselt übertragen und ausschließlich zur Bearbeitung Ihrer Datenschutzanfrage verwendet.
      </p>
    </Form>;
}
export default function Kontakt() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return;
}